import { render, staticRenderFns } from "./workPointDetail.vue?vue&type=template&id=f039929c&scoped=true"
import script from "./workPointDetail.vue?vue&type=script&lang=js"
export * from "./workPointDetail.vue?vue&type=script&lang=js"
import style0 from "./workPointDetail.vue?vue&type=style&index=0&id=f039929c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f039929c",
  null
  
)

export default component.exports